import { create } from 'zustand';

import Const from '../Constants';

export const useEpicsStore = create((set, get) => ({
  epics: [],

  showCompleted: false,

  // Load all from backend
  loadEpics: async (auth) => {
    try {
        const { showCompleted } = get();
        // Load all tasks from backend
        const queryParams = new URLSearchParams({
          includeDone: showCompleted
        });
        const idToken = await auth.currentUser.getIdToken();
        const theURL = `${process.env.REACT_APP_BASE_URL}/epics?${queryParams}`;
  
        const response = await fetch(theURL, {
          headers: new Headers({
            Authorization: idToken
          })
        });
        const epics = await response.json();
        set({ epics });
      } catch (error) {
        console.error(error.message);
      }
  },

  addEpic: async (auth) => {
    try {
      const idToken = await auth.currentUser.getIdToken();
      const theURL = process.env.REACT_APP_BASE_URL + '/epics';
  
      const response = await fetch(theURL, {
        method: Const.HttpPost,
        headers: new Headers({
          Authorization: idToken,
          Accept: Const.AppJson,
          [Const.ContentType]: Const.AppJson
        })
      });
  
      if (!response.ok) throw new Error("Failed to add epic");
  
      const newEpic = await response.json();
  
      // Add the new epic to the end of the store
      set((state) => ({
        epics: [...state.epics, newEpic]
      }));
  
    } catch (error) {
      console.error(error.message);
    }
  },

  deleteEpic: async (auth, epicId) => {
    try {

      // Remove the deleted epic from the local store state
      set((state) => ({
        epics: state.epics.filter(epic => epic.id !== epicId)
      }));

      // Server request to delete the epic
      const idToken = await auth.currentUser.getIdToken();
      const theURL = process.env.REACT_APP_BASE_URL + '/epics';
      await fetch(theURL, {
        method: Const.HttpDelete,
        headers: new Headers({
          Authorization: idToken,
          Accept: Const.AppJson,
          [Const.ContentType]: Const.AppJson
        }),
        body: JSON.stringify({
          epicId
        })
      });

    } catch (error) {
      console.error(error.message);
    }
  },

  updateEpic: async (auth, epicId, title) => {
    try {
      if (title === null) {
        throw new Error('updateEpic: All params are null');
      }
  
      const idToken = await auth.currentUser.getIdToken();
      const theURL = process.env.REACT_APP_BASE_URL + '/epics';
  
      let body = { epicId };
      if (title !== null) {
        body[Const.sTitle] = title;
      }
  
      const response = await fetch(theURL, {
        method: Const.HttpPatch,
        headers: new Headers({
          Authorization: idToken,
          Accept: Const.AppJson,
          [Const.ContentType]: Const.AppJson
        }),
        body: JSON.stringify(body)
      });
  
      if (!response.ok) throw new Error("Failed to update epic");
  
      // Update local store
      set((state) => ({
        epics: state.epics
          .map((epic) =>
            epic.id === epicId ? { ...epic, ...(title && { title }) } : epic
          )
      }));
  
    } catch (error) {
      console.error(error.message);
    }
  },

  setShowCompleted: (value) => set({ showCompleted: value })
}));
